import { Http } from "@/network/http"
import { Filters } from "@/utils/constants"

export const API_PREFIX_PATH = "/finance-report"

export const fetchFinanceReport = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}
